import { apiSlice } from "./apiSlice";
import { FilteredPagedQueryResult, FilteredPagedModel } from "../../entities/common";
import { StatInfoModel, StatInfoCommonInfoModel, StatInfoComputeModel, StatInfoGroupComputeModel } from "../../entities/statInfo";
import { TagTypes } from "./apiSlice";
import { getQuerySearchParams } from "../../utils";

export const statInfoApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // StatInfo

    getStatInfoCommonInfo: builder.query<StatInfoCommonInfoModel, undefined>({
      query: () => "/statInfo/commonInfo",
      providesTags: [{ type: TagTypes.StatInfo, id: "LIST" }],
    }),

    getStatInfosFilteredPaged: builder.query<FilteredPagedQueryResult<StatInfoModel>, FilteredPagedModel>({
      query: ({ page = 1, pageSize = 10, searchTerm = "", sortFieldName = "", descending = false, ...rest }: FilteredPagedModel) => {
        let url = `/statInfo/pageable?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortFieldName=${sortFieldName}&descending=${descending}`;
        const restParams = getQuerySearchParams(rest);
        if (restParams) {
          url += `&${restParams}`;
        }
        return url;
      },
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: TagTypes.StatInfo, id: "PARTIAL-LIST" },
              ...result.data.map(({ id }) => ({
                type: TagTypes.StatInfo,
                id,
              })),
            ]
          : [{ type: TagTypes.StatInfo, id: "PARTIAL-LIST" }],
    }),

    computeAndCacheStatInfos: builder.mutation({
      query: (model: StatInfoComputeModel) => ({
        url: "/statInfo/computeAndCache",
        method: "POST",
        body: model,
      }),
      invalidatesTags: [
        { type: TagTypes.StatInfo, id: "LIST" },
        { type: TagTypes.StatInfo, id: "PARTIAL-LIST" },
      ],
    }),

    computeAndCacheGroupStatInfos: builder.mutation({
      query: (model: StatInfoGroupComputeModel) => ({
        url: "/statInfo/computeAndCache/group",
        method: "POST",
        body: model,
      }),
      invalidatesTags: [
        { type: TagTypes.StatInfo, id: "LIST" },
        { type: TagTypes.StatInfo, id: "PARTIAL-LIST" },
      ],
    }),
  }),
});

export const {
  useGetStatInfoCommonInfoQuery,
  useGetStatInfosFilteredPagedQuery,
  useComputeAndCacheStatInfosMutation,
  useComputeAndCacheGroupStatInfosMutation,
} = statInfoApi;
